export enum AssetManagementLabels {
  GeneralLedger = 'General Ledger',
  TrialBalance = 'Trial Balance',
  IncomeStatement = 'Income Statement',
  BalanceSheet = 'Balance Sheet',
  RegularAccount = 'Regular Account',
  CategoryAccount = 'Category Account',
  CategoryAccounts = 'Category Accounts',
  ChartOfAccounts = 'Chart of Accounts',
  AccountMapping = 'Account Mapping',
  AccountTree = 'Account Tree',
  AssetBudget = 'Asset Budget',
  TrailingIncomeStatement = 'Trailing Income Statement',
}
